const API_BASE_URL = process.env.BASE_URL

export const PASSWORD_ENDPOINTS = {
    CHANGE_PASSWORD: API_BASE_URL + "/user/me/change-password/",
    HAS_PASSWORD: API_BASE_URL + "/user/me/has-password/",
}
